import { DatePipe } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

import { ActiveSorting } from '../../abstracts/table-base.abstract'
import { TypedTemplateDirective } from '../../directives/typed-template.directive'
import { Branch } from '../../models/branch.model'
import { ProcessBarComponent } from '../../pages/upload/process-bar/process-bar.component'
import { ProcessErrorComponent } from '../../pages/upload/process-error/process-error.component'
import { HighLightTextPipe } from '../../pipes/high-light-text.pipe'
import { MergeColumnsPipe } from '../../pipes/merge-columns.pipe'
import { BranchStatusComponent } from '../branch-status/branch-status.component'
import { NumberComponent } from '../number/number.component'
import {
  ChangeEventParams,
  TableColumn,
  TableComponent,
  TableDataBase,
} from '../table/table.component'
import { UserComponent } from '../user/user.component'

export type TableData = TableDataBase & Branch

@Component({
  selector: 'app-branch-base',
  imports: [
    TableComponent,
    TranslatePipe,
    DatePipe,
    HighLightTextPipe,
    NumberComponent,
    UserComponent,
    MergeColumnsPipe,
    TypedTemplateDirective,
    BranchStatusComponent,
    ProcessBarComponent,
    ProcessErrorComponent,
  ],
  templateUrl: './branch-base.component.html',
})
export class BranchBaseComponent {
  public typeToken!: { item: string; currentRow: TableData }

  @Input({ required: true }) public isLoading: boolean = false
  @Input({ required: false }) public sword!: string

  @Input({ required: true }) public tableColumns!: TableColumn[]
  @Input({ required: true }) public tableData!: TableData[]
  @Input({ required: false }) public removeColumns!: string[]
  @Input({ required: true }) public total!: number
  @Input({ required: true }) public pageIndex!: number
  @Input({ required: true }) public pageSize!: number
  @Input({ required: true }) public activeSorting!: ActiveSorting
  @Input({ required: false }) public customNoResultText?: string = undefined

  @Output() public changeHandler = new EventEmitter<ChangeEventParams>()

  public changeTableHandler(params: ChangeEventParams): void {
    this.pageIndex = params.pageIndex
    this.pageSize = params.pageSize
    this.activeSorting = params.sort.filter((s) => s.value)

    this.changeHandler.emit({
      sort: this.activeSorting,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
    })
  }
}
